import React from 'react';
import RadioComponent from 'shared/components/RadioComponent';
import Label from 'shared/components/Label';
import Tooltip from 'shared/components/Tooltip';

const PrintConfirmation = (props) => {
  const {
    name,
    parameters,
    onChangeParameter,
    children,
    errorMessage,
    label,
    required,
    tooltip,
    groupName,
    yesLabel,
    yesValue,
    noLabel,
    noValue,
    inputClassName,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);
  const value = parameters[name];

  return (
    <div className="form-group">
      <Label label={label} required={required}>
        <Tooltip id={`tooltip-${name}`} title={tooltip} />
      </Label>
      <div className="radio-group">
        <RadioComponent
          {...props}
          checked={value === noValue}
          inline
          inputId={`print-confirmation-no-${groupName}`}
          inputClassName={inputClassName}
          label={noLabel}
          name={name}
          onChange={onChange}
          value={noValue}
          groupName={groupName} />
        <RadioComponent
          {...props}
          checked={value === yesValue}
          inline
          inputId={`print-confirmation-yes-${groupName}`}
          inputClassName={inputClassName}
          label={yesLabel}
          name={name}
          onChange={onChange}
          value={yesValue}
          groupName={groupName} />
        <div className="error-place" />
      </div>
      {errorMessage}
      {children}
    </div>
  );
};

PrintConfirmation.defaultProps = {
  name: 'print_confirmation',
  label: 'Send me a Check Plot?',
  yesLabel: 'Yes',
  yesValue: '1',
  noLabel: 'No',
  noValue: '0',
  required: true,
};

export default PrintConfirmation;
